import { useLocation } from 'react-router-dom'
import { getLanguageFromPath, createLocalizedPath } from '../utils/languageUtils'

/**
 * Хук для создания локализованных ссылок
 * @returns {Function} Функция для создания локализованного пути
 */
export const useLocalizedLink = () => {
  const location = useLocation()
  
  const getLocalizedLink = (path) => {
    const [pathOnly, hash] = path.split('#')
    const currentLang = getLanguageFromPath(location.pathname)
    const localized = createLocalizedPath(pathOnly, currentLang)
    return hash ? `${localized}#${hash}` : localized
  }
  
  return getLocalizedLink
}

